import {  host_php_gate_url, host_haiji_url, host_admin_func, host_sso_url, host_admin_gateway_func } from '@/api/host'
const userServerName = 'users'
var commonApi = {
	commonAuth: `${host_php_gate_url}/auth/issue`,//获取用户权限数据
	commonLogin: `${host_sso_url}/sso/login`,//用户登录
	refreshTokenUrl: `${host_sso_url}/sso/refresh`,//刷新token
    commonLogout: `${host_sso_url}/sso/logout`,//用户登出
	// 钉钉登录
    getDingQRCodeUrl: `${host_sso_url}/sso/login/dingtalk/config`, //根据应用名称和钉钉账户标识 获取钉钉扫码登录配置
    dingQRCodeLoginUrl: `${host_sso_url}/sso/login/code/dingtalk`, //员工钉钉扫码登录
	getDingCodeUrl:`${host_sso_url}/sso`,//获取钉钉验证码
    judgeNeedCodeUrl: `${host_admin_gateway_func(userServerName,'')}/sso/status`,//获取是否需要钉钉验证码状态
    getResetDingCodeUrl: `${host_admin_gateway_func(userServerName,'')}/sso/send_password_update_code`,//发送密码重置口令
    resetPwdUrl: `${host_admin_gateway_func(userServerName,'')}/sso/update-password`,//用户修改密码（修改成功后，用户需手动重新登录）
	// OSS
	getOssSignatureUrl: `${host_haiji_url}/v2/admin/oss/signature`,//获取oss签名
	getPrivateFileUrl: `${host_php_gate_url}/oss/auth`,//获取私密文件路径
	// 权限相关
	isManager: `${host_admin_gateway_func(userServerName,'')}/right/right/isManager`, // 当前登录人是否是超级管理员 http://apidoc.epetbar.com/#/home/project/inside/api/detail?groupID=686&childGroupID=723&apiID=2335&projectName=用户中心&projectID=79
	getMenu: `${host_admin_gateway_func(userServerName,'')}/right/right/menu`, // 获取当前登录人的菜单权限 http://apidoc.epetbar.com/#/home/project/inside/api/detail?groupID=686&childGroupID=723&apiID=2317&projectName=%E7%94%A8%E6%88%B7%E4%B8%AD%E5%BF%83&projectID=79
    getBtn: `${host_admin_gateway_func(userServerName,'')}/right/right/btn`, // 获取当前登录人的按钮权限 http://apidoc.epetbar.com/#/home/project/inside/api/detail?groupID=686&childGroupID=723&apiID=2318&projectName=%E7%94%A8%E6%88%B7%E4%B8%AD%E5%BF%83&projectID=79
    // 商家登录相关
    businessLoginUrl: `${host_haiji_url}/v1/admin/client/login`, // 商家登录
    businessRefreshTokenUrl: `${host_haiji_url}/v1/admin/client/refresh`, // 商家刷新token
    businessLogoutUrl: `${host_haiji_url}/v1/admin/client/logout`, // 商家登出

    // 转发中台网关接口
    transferGatewayUrl: `${host_haiji_url}/v1/admin/gateway/request`, // 转发所有中台接口网关地址
};

export { commonApi }